"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.userGroupParentTribesCollectionIdSelector = exports.deleteUserIsLoadingSelector = exports.deleteUserErrorSelector = exports.deletedUserIdSelector = exports.deleteUserInfoClientIsLoadingSelector = exports.deleteUserInfoClientErrorSelector = exports.deletedUserInfoClientIdSelector = exports.deleteUserInfoGroupIsLoadingSelector = exports.deleteUserInfoGroupErrorSelector = exports.deletedUserInfoGroupIdSelector = exports.loadUserInfoGroupSelector = exports.editUserClientErrorSelector = exports.editUserClientIsLoadingSelector = exports.editUserClientSuccessSelector = exports.editUserInfoErrorSelector = exports.editUserInfoIsLoadingSelector = exports.editedUserInfoIdSelector = exports.loadUserInfoErrorSelector = exports.loadUserInfoIsLoadingSelector = exports.loadUserInfoSelector = void 0;

var _reselect = require("reselect");

var userStateSelector = function userStateSelector(state) {
  return state.user;
};

var userInfoStateSelector = (0, _reselect.createSelector)(userStateSelector, function (user) {
  return user.info;
});
var loadUserInfoStateSelector = (0, _reselect.createSelector)(userInfoStateSelector, function (info) {
  return info.loadUserInfo;
});
var loadUserInfoSelector = (0, _reselect.createSelector)(loadUserInfoStateSelector, function (info) {
  return info.userInfo;
});
exports.loadUserInfoSelector = loadUserInfoSelector;
var loadUserInfoIsLoadingSelector = (0, _reselect.createSelector)(loadUserInfoStateSelector, function (info) {
  return info.isLoading;
});
exports.loadUserInfoIsLoadingSelector = loadUserInfoIsLoadingSelector;
var loadUserInfoErrorSelector = (0, _reselect.createSelector)(loadUserInfoStateSelector, function (info) {
  return info.error;
});
exports.loadUserInfoErrorSelector = loadUserInfoErrorSelector;
var editUserInfoStateSelector = (0, _reselect.createSelector)(userInfoStateSelector, function (info) {
  return info.editUserInfo;
});
var editedUserInfoIdSelector = (0, _reselect.createSelector)(editUserInfoStateSelector, function (editUserInfo) {
  return editUserInfo.editedUserId;
});
exports.editedUserInfoIdSelector = editedUserInfoIdSelector;
var editUserInfoIsLoadingSelector = (0, _reselect.createSelector)(editUserInfoStateSelector, function (editUserInfo) {
  return editUserInfo.isLoading;
});
exports.editUserInfoIsLoadingSelector = editUserInfoIsLoadingSelector;
var editUserInfoErrorSelector = (0, _reselect.createSelector)(editUserInfoStateSelector, function (editUserInfo) {
  return editUserInfo.error;
});
exports.editUserInfoErrorSelector = editUserInfoErrorSelector;
var editUserClientStateSelector = (0, _reselect.createSelector)(userInfoStateSelector, function (info) {
  return info.editUserClient;
});
var editUserClientSuccessSelector = (0, _reselect.createSelector)(editUserClientStateSelector, function (editUserClient) {
  return editUserClient.success;
});
exports.editUserClientSuccessSelector = editUserClientSuccessSelector;
var editUserClientIsLoadingSelector = (0, _reselect.createSelector)(editUserClientStateSelector, function (editUserClient) {
  return editUserClient.isLoading;
});
exports.editUserClientIsLoadingSelector = editUserClientIsLoadingSelector;
var editUserClientErrorSelector = (0, _reselect.createSelector)(editUserClientStateSelector, function (editUserClient) {
  return editUserClient.error;
});
exports.editUserClientErrorSelector = editUserClientErrorSelector;
var loadUserInfoGroupSelector = (0, _reselect.createSelector)(loadUserInfoSelector, function (userInfo) {
  return userInfo ? userInfo.groups && userInfo.groups[0] : null;
});
exports.loadUserInfoGroupSelector = loadUserInfoGroupSelector;
var deleteUserInfoGroupStateSelector = (0, _reselect.createSelector)(userInfoStateSelector, function (info) {
  return info.deleteUserInfoGroup;
});
var deletedUserInfoGroupIdSelector = (0, _reselect.createSelector)(deleteUserInfoGroupStateSelector, function (deleteUserInfoGroup) {
  return deleteUserInfoGroup.deletedUserGroupId;
});
exports.deletedUserInfoGroupIdSelector = deletedUserInfoGroupIdSelector;
var deleteUserInfoGroupErrorSelector = (0, _reselect.createSelector)(deleteUserInfoGroupStateSelector, function (deleteUserInfoGroup) {
  return deleteUserInfoGroup.error;
});
exports.deleteUserInfoGroupErrorSelector = deleteUserInfoGroupErrorSelector;
var deleteUserInfoGroupIsLoadingSelector = (0, _reselect.createSelector)(deleteUserInfoGroupStateSelector, function (deleteUserInfoGroup) {
  return deleteUserInfoGroup.isLoading;
});
exports.deleteUserInfoGroupIsLoadingSelector = deleteUserInfoGroupIsLoadingSelector;
var deleteUserInfoClientStateSelector = (0, _reselect.createSelector)(userInfoStateSelector, function (info) {
  return info.deleteUserInfoClient;
});
var deletedUserInfoClientIdSelector = (0, _reselect.createSelector)(deleteUserInfoClientStateSelector, function (deleteUserInfoClient) {
  return deleteUserInfoClient.deletedUserClientId;
});
exports.deletedUserInfoClientIdSelector = deletedUserInfoClientIdSelector;
var deleteUserInfoClientErrorSelector = (0, _reselect.createSelector)(deleteUserInfoClientStateSelector, function (deleteUserInfoClient) {
  return deleteUserInfoClient.error;
});
exports.deleteUserInfoClientErrorSelector = deleteUserInfoClientErrorSelector;
var deleteUserInfoClientIsLoadingSelector = (0, _reselect.createSelector)(deleteUserInfoClientStateSelector, function (deleteUserInfoClient) {
  return deleteUserInfoClient.isLoading;
});
exports.deleteUserInfoClientIsLoadingSelector = deleteUserInfoClientIsLoadingSelector;
var deleteUserStateSelector = (0, _reselect.createSelector)(userInfoStateSelector, function (info) {
  return info.deleteUser;
});
var deletedUserIdSelector = (0, _reselect.createSelector)(deleteUserStateSelector, function (deleteUser) {
  return deleteUser.deletedUserId;
});
exports.deletedUserIdSelector = deletedUserIdSelector;
var deleteUserErrorSelector = (0, _reselect.createSelector)(deleteUserStateSelector, function (deleteUser) {
  return deleteUser.error;
});
exports.deleteUserErrorSelector = deleteUserErrorSelector;
var deleteUserIsLoadingSelector = (0, _reselect.createSelector)(deleteUserStateSelector, function (deleteUser) {
  return deleteUser.isLoading;
});
exports.deleteUserIsLoadingSelector = deleteUserIsLoadingSelector;
var userGroupParentTribesCollectionIdSelector = (0, _reselect.createSelector)(loadUserInfoSelector, function (userInfo) {
  var _userInfo$groups$, _userInfo$groups$$gro, _userInfo$groups$$gro2, _userInfo$groups$$gro3;

  return userInfo ? userInfo.groups && ((_userInfo$groups$ = userInfo.groups[0]) === null || _userInfo$groups$ === void 0 ? void 0 : (_userInfo$groups$$gro = _userInfo$groups$.group) === null || _userInfo$groups$$gro === void 0 ? void 0 : (_userInfo$groups$$gro2 = _userInfo$groups$$gro.groupParent) === null || _userInfo$groups$$gro2 === void 0 ? void 0 : (_userInfo$groups$$gro3 = _userInfo$groups$$gro2.settings) === null || _userInfo$groups$$gro3 === void 0 ? void 0 : _userInfo$groups$$gro3.tribesCollectionId) : null;
});
exports.userGroupParentTribesCollectionIdSelector = userGroupParentTribesCollectionIdSelector;
var _default = {
  loadUserInfoSelector: loadUserInfoSelector,
  loadUserInfoErrorSelector: loadUserInfoErrorSelector,
  loadUserInfoIsLoadingSelector: loadUserInfoIsLoadingSelector,
  loadUserInfoGroupSelector: loadUserInfoGroupSelector,
  editedUserInfoIdSelector: editedUserInfoIdSelector,
  editUserInfoErrorSelector: editUserInfoErrorSelector,
  editUserInfoIsLoadingSelector: editUserInfoIsLoadingSelector,
  editUserClientSuccessSelector: editUserClientSuccessSelector,
  editUserClientErrorSelector: editUserClientErrorSelector,
  editUserClientIsLoadingSelector: editUserClientIsLoadingSelector,
  deletedUserInfoGroupIdSelector: deletedUserInfoGroupIdSelector,
  deleteUserInfoGroupErrorSelector: deleteUserInfoGroupErrorSelector,
  deleteUserInfoGroupIsLoadingSelector: deleteUserInfoGroupIsLoadingSelector,
  deletedUserInfoClientIdSelector: deletedUserInfoClientIdSelector,
  deleteUserInfoClientErrorSelector: deleteUserInfoClientErrorSelector,
  deleteUserInfoClientIsLoadingSelector: deleteUserInfoClientIsLoadingSelector,
  deletedUserIdSelector: deletedUserIdSelector,
  deleteUserErrorSelector: deleteUserErrorSelector,
  deleteUserIsLoadingSelector: deleteUserIsLoadingSelector,
  userGroupParentTribesCollectionIdSelector: userGroupParentTribesCollectionIdSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map